module.exports = __webpack_public_path__ + "img/interface.8ddf0c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/interface.png
// module id = 1SeG
// module chunks = 0